/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  useCallback,
  useContext,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
} from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import Modal from 'components/UI/Modal';

const { lPink } = colors;

const Transcript = ({
  id,
  onClose,
  children,
  ...props
}: {
  id?: any;
  onClose?: any;
  children?: any;
}) => {
  //

  let [text, btn] = children?.props?.children;

  btn = React.cloneElement(btn, {
    onClick() {
      onClose();
    },
  });

  return (
    <Modal onClose={onClose}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: space-between;
          width: 100%;
          min-height: 50vh;
          padding: 30px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex: 1;
            align-items: center;
            margin: 0 0 20px 0;
          `}
        >
          {text}
        </div>
        <div
          css={css`
            display: flex;
            justify-content: center;
            width: 100%;
          `}
        >
          <div>{btn}</div>
        </div>
      </div>
    </Modal>
  );
};

export default Transcript;
